export default __webpack_public_path__ + "static/media/IMG_2376.0e27fd57.jpg";